import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import AddHomeworkPerformanceForm from "../../components/AddHomeworkPerformanceForm/AddHomeworkPerformanceForm";
import Layout from "../../components/shared/Layout/Layout";

const AddHomeworkPerformancePage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Homework Performance`}>
        {edit && id && grades ? (
          <AddHomeworkPerformanceForm grades={grades} />
        ) : (
          <AddHomeworkPerformanceForm grades={grades ? grades : []} />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddHomeworkPerformancePage);
